import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { List, Datagrid, TextField, ReferenceField, EditButton, Edit, SimpleForm, ReferenceInput, TextInput, SelectInput, DisabledInput, LongTextInput, Create, Filter } from 'react-admin';

/*const PostTitle = ({ record }) => {
	return <span>Post {record ? `${record.title}` : ''}</span>;
}*/
const AdminTitle = ({ record }) => {
	return <span>{record ? `${record.username}` : ''}</span>;
}
const DescriptionField = ({ record = {} }) => {
	console.log(record["description"]["asdf"]);
	return (<span>{record["description"]["asdf"]}</span>);
};
DescriptionField.defaultProps = { label: '소개문' };
/*const PostFilter = (props) => (
	<Filter {...props}>
		<TextInput label="Search" source="q" alwaysOn />
		<ReferenceInput label="User" source="userId" reference="users" allowEmpty>
			<SelectInput optionText="name" />
		</ReferenceInput>
	</Filter>
);*/

export const AdminList = props => (
	<List /*filters={<PostFilter />}*/ {...props} title="관리자">
		<Datagrid>
			<TextField source="id" label="일련번호" />
			<TextField source="username" label="ID" />
			<EditButton />
		</Datagrid>
	</List>
)
export const AdminEdit = props => (
	<Edit title={<AdminTitle />} {...props}>
		<SimpleForm>
			<TextField source="id" label="일련번호" />
			<TextInput source="username" label="ID" />
		</SimpleForm>
	</Edit>
)
export const AdminCreate = props => (
	<Create {...props}>
		<SimpleForm>
			<TextInput source="username" label="ID" />
			<TextInput source="password" label="비밀번호" />
		</SimpleForm>
	</Create>
)
/*export const PostEdit = props => (
	<Edit title={<PostTitle />} {...props}>
		<SimpleForm>
			<DisabledInput source="id" />
			<ReferenceInput source="userId" reference="users"><SelectInput optionText="name" /></ReferenceInput>
			<TextInput source="title" />
			<LongTextInput source="body" />
		</SimpleForm>
	</Edit>
);
export const PostCreate = props => (
	<Create {...props}>
		<SimpleForm>
			<ReferenceInput source="userId" reference="users">
				<SelectInput optionText="name" />
			</ReferenceInput>
			<TextInput source="title" />
			<LongTextInput source="body" />
		</SimpleForm>
	</Create>
)*/